import { errorMessages } from "../../constants/errorMessages.js";
import { getLocalStorageValues } from "../../utils/localStorageStateUniqueKeyGenerator.js";

export const signupRemainingFieldsErrorHandler = (
  currentMemberData,      // ← your backend “truth”
  currentContextType,     // e.g. "signUpForm" or "resetPasswordForm"
  setFirstNameValueError,
  setLastNameValueError,
  setEmailValueError,
  setThumbnailError,
  forcePhoto,             // your SIGNUP_FORCE_PHOTO flag
  fileUpload              // the File object if chosen
) => {
  // 1) grab whatever drafts are in localStorage
  const keys = [
    "firstNameValue",
    "lastNameValue",
    "emailValue",
    "usernameReferral",
    "thumbnailPreference",
  ];
  const values = getLocalStorageValues(keys, currentContextType);

  // 2) overlay with any values the server already has
  const merged = {
    firstNameValue:    currentMemberData.firstName   || values.firstNameValue   || "",
    lastNameValue:     currentMemberData.lastName    || values.lastNameValue    || "",
    emailValue:        currentMemberData.email       || values.emailValue       || "",
    // if you also track thumbnailPreference on the server you could do:
    // thumbnailPreference: currentMemberData.thumbnailPreference || values.thumbnailPreference,
  };

  let errors = {};

  // 3) required‐field checks
  ["firstNameValue","lastNameValue","emailValue"].forEach((key) => {
    if (!merged[key].trim()) {
      // map "firstNameValue" → errorMessages.firstName
      const field = key.replace("Value", "");
      errors[`${key}Error`] = errorMessages[field] || `${field} is required`;
    }
  });

  // 4) photo‐required check: only if forced AND
  //    - no new fileUpload AND
  //    - no existing profileImageUrl on the server
  const hasExistingPhoto = Boolean(currentMemberData.profileImageUrl);
  if (forcePhoto && !fileUpload && !hasExistingPhoto) {
    errors.thumbnailError = errorMessages.profileSignupPic;
  }

  // 5) write errors back into React state
  setFirstNameValueError(errors.firstNameValueError || "");
  setLastNameValueError( errors.lastNameValueError   || "");
  setEmailValueError(    errors.emailValueError      || "");
  setThumbnailError(     errors.thumbnailError       || "");

  return errors;
};
